import React, { useState, useEffect, useCallback } from "react";
import { Box, Portal } from "@mui/material";
import "react-lazy-load-image-component/src/effects/blur.css";
import { ICart, IDetail, IModifier, IModifierGroup, IOrderModifiers } from "../../../types/menu";
import { useInfoStore } from "../../../store/userInfo";
import { useTranslation } from "react-i18next";
import { logging } from "../../../services/setting.service";
import { useWindowDimensions } from "../../../App";
import { useOrderStore } from "../../../store/order";
import { Axios } from "../../../api/axios";
import { useRecommendStore } from "../../../store/recommend";
import { useQuery } from "@tanstack/react-query";
import RecommendLandscape from "./RecommendLandscape";
import RecommendPortrait from "./RecommendPortrait";
import { RecommendDetailContext } from "./RecommendDetailContext";
import './Recommend.css';
import { logger } from '../../../utils/logger';

// 플랫폼 확인 Android
const isAndroid = /Android/i.test(navigator.userAgent);

const IMAGE_URL = process.env.REACT_APP_S3_IMAGE_PAPH;

const DynamicDetail = () => {
  const { orientation } = useWindowDimensions();
  return orientation === "landscape" ? <RecommendLandscape /> : <RecommendPortrait />;
};

const RecommendItemMain = (props: { recommendId: number; openRecommend: any; setRecommendId: any; setOpenRecommend: any; }) => {
    const { recommendId ,openRecommend, setRecommendId, setOpenRecommend } = props;
    const { userInfo, tableInfo, isAyce } = useInfoStore();
    const storeId = userInfo?.storeId;
    const { height } = useWindowDimensions();
    const {t} =  useTranslation(`${storeId}`)
    const { setCart, setSnackMode, setShowSnackbar, setLimitValue} = useOrderStore();
    const { checkedModifierPrice , resetOrder, setOrderPrice} = useRecommendStore();
    const [quantity, setQuantity] = useState(1)
    const [selectRequired, setSelectRequired] = useState<boolean>(false);
    const [selectOptionals, setSelectOptionals] = useState<JSON[]>([]);
    const [recommendItem, setRecommendItem] = useState<IDetail|null>(null)
    const [showSnack, setShowSnack] = useState(false)
    const [mode, setMode] = useState(0);
    const [modifierStatus, setModifierStatus] = useState(false);
    const [preRecommendOrder, setPreRecommendOrder] = useState<ICart | null>(null);

    const generatePaths = (groups: IModifierGroup[], parentPath: string = ''): IModifierGroup[] => {
      return groups.map((group, groupIndex) => {
        const groupPath = `${parentPath}/g-${group.id}-${groupIndex}`;
        return {
          ...group,
          isExpanded: false,
          path: groupPath,
          modifiers: group.modifiers.map((modifier, modifierIndex) => ({
            ...modifier,
            path: `${groupPath}/m-${modifier.id}-${modifierIndex}`,
            modifiers: modifier.modifiers
              ? generatePaths(modifier.modifiers, `${groupPath}/m-${modifier.id}-${modifierIndex}`)
              : [],
          })),
        };
      });
    };

    const getRcommendDetail = async () => {
      const response = await Axios(
        { 
          method: 'GET',
          // url: `/v2/menus/items/${recommendId}`
          url: `/v2/menus/items/${recommendId}/tables/${tableInfo.id}/recommend`
          // url: `v2/menus/items/${recommendId}/categories/${selectedCategory.id}/tables/${tableInfo.id}`
        })
    
        if(response.data !== undefined && response.data && response.data.modifierGroups) {
          response.data.modifierGroups = generatePaths(
            response.data.modifierGroups,
            `${recommendId}`
          );
          response.data.modifierGroups?.forEach( (modifiers: { isRequired: any; }) => {
            if(modifiers.isRequired) {
              logger.log(modifiers.isRequired)
                const addcheck = {checked: null}
                modifiers = Object.assign(modifiers, addcheck);
                response.data.hasRequired = true 
            }
          })
        }
        logger.log('recommend', response.data)
        resetOrder()
        setOrderPrice(response.data.itemPrice)
        setRecommendItem({...response.data, quantity: response?.data.minRequired})
        setQuantity(response.data.minRequired)
        return response.data;
    }
  
    const { status, data, error } = useQuery({ 
      queryKey: [`recommendDetail`, recommendId ], 
      queryFn: () => getRcommendDetail(),  
      enabled:  recommendId !== 0, 
    })

    const handleClose =() => {
      // if (!isBrowser) {
      //   if (window.ReactNativeWebView !== undefined) {
      //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
      //   } else if(window.Android !== undefined){
      //     window.Android.postMessage(JSON.stringify({'type':'play'}));
      //   }
      // }
      setOpenRecommend(false);
      setRecommendItem(null)
      setRecommendId(0)
    }

    const handleAddCount = async (item: ICart) => {
      if(!recommendItem) return;
      if(isAyce) {
        if(item!.maxAllowedPerTable === 0) {
          setLimitValue(item!.maxAllowedPerTable)
          setSnackMode(12)
          setShowSnackbar(true)
          return
        }
        if(item!.maxAllowedPerTable) {
          // setQuantity((prev: number) => (prev >= itemDetail!.maxAllowedPerTable) ? quantity : prev+1)
          const itemQuantity = item.quantity >= item!.maxAllowedPerTable ? item!.quantity : item!.quantity+1
          setPreRecommendOrder({...item, quantity: itemQuantity});
        }
        else {
          setPreRecommendOrder({...item, quantity: item.quantity +  1});
        }
      } else {
          setPreRecommendOrder({...item, quantity: item.quantity +  1});
      }
      // }
    }

    const handleSubCount = (item: ICart) => {
      if(!recommendItem) return;
      const itemQuantity = recommendItem.quantity === recommendItem.minRequired ? recommendItem.minRequired : recommendItem.quantity - 1;
      if(recommendItem.minRequired && itemQuantity < recommendItem.minRequired) {
        setLimitValue(recommendItem.minRequired);
        setSnackMode(13);
        setShowSnackbar(true);
        return;
      }
      setRecommendItem({...recommendItem, quantity: itemQuantity});
    }

    const handleAddtoCart = async (e: any, orderItems: IDetail): Promise<void> => {
      logger.log('addtocart',orderItems)

      const key =  orderItems.itemId
      // const name = detailItem.itemName;
      const price = orderItems.itemPrice;
      const hasModifier = orderItems.hasModifier;
      const specialRequest =  orderItems.specialRequest
      // dispatch(setAddSnackbar(true));
      if(hasModifier && !selectRequired) {
        logger.log('require false')
        setSnackMode(0)
        setShowSnackbar(true)

        return; 
      }

      const orderItem:ICart = {
        categoryId: orderItems.categoryId,
        itemId: key,
        itemName: orderItems.itemName,
        // orderTypeId?: number,
        newItem: true,
        quantity: orderItems.quantity,
        isAyce: isAyce,
        itemPrice: price,
        hasModifier: hasModifier,
        itemWithModifierPrice: 0,
        maxAllowed: orderItems.maxAllowed,
        minRequired:  orderItems.minRequired,
        categoryLimits: orderItems.categoryLimits,
        maxAllowedPerTable: orderItems.maxAllowedPerTable,
        orderModifiers: [],
      }
      if(specialRequest !== undefined) Object.assign(orderItem, {specialRequest: specialRequest})
      if(hasModifier) {
        const checkedModifiers: IOrderModifiers[] = getCheckedModifiers(orderItems.modifierGroups!);
        if (checkedModifiers.length > 0) {
          orderItem.orderModifiers = checkedModifiers;
        } else {
          orderItem.orderModifiers = [];
        }
      }
      // addRecommendsMenu();
      logger.log('data', orderItem)
      // await setCart({item: menu, type: "add"})
      try {
        await useOrderStore.getState().setCart({ item: orderItem, type: 'add' });
        logger.log('Cart updated successfully');
        // 추가 작업 수행
        const { updateCart } = useOrderStore.getState();
        if (updateCart) {
          logger.log('recommend add to cart');
          setSnackMode(14);
          setShowSnackbar(true);
        }
      } catch (error) {
        logger.error('Failed to update cart', error);
        // 오류 처리
      }

      // setSelectOptionals([])
      checkedModifierPrice({price: 0, type: 'reset'});
      setSelectRequired(false);

      setOpenRecommend(false);
      setRecommendItem(null)
      setRecommendId(0)

      // setIsAddCart(false)
      // setIsAddCart(true)
      // dispatch(setDetailRequire(false))
    }

    const getCheckedModifiers = (groups: IModifierGroup[]): IOrderModifiers[] => {
        return groups.flatMap((group: IModifierGroup) => {
          // Calculate the cumulative quantity for the current group
          const modifierGroupCount = group.modifiers.reduce(
            (sum: number, modifier: IModifier) => sum + (modifier.quantity || 0),
            0
          );
      
          return group.modifiers
            .filter((modifier: IModifier) => modifier.quantity !== null && modifier.quantity > 0)
            .map((modifier: IModifier) => {
              return {
                modifierGroupId: group.id, // Group ID
                modifierGroupName: group.modifierGroupName, // Group Name
                modifierId: modifier.id, // Modifier ID
                modifierName: modifier.modifierName, // Modifier Name
                modifierPrice: modifier.modifierPrice, // Modifier Price
                quantity: modifier.quantity!, // Modifier's selected quantity
                isRequired: group.isRequired,
                path: group.path,
                maxAllowedGroup: group.maxAllowed,
                minRequiredGroup: group.minRequired,
                modifierGroupCount: modifierGroupCount, // Total quantity selected in this group
                hasNestedModifierGroups: modifier.hasNestedModifierGroups,
                orderModifiers: modifier.modifiers
                  ? getCheckedModifiers(modifier.modifiers as IModifierGroup[])
                  : [],
              };
            });
        });
      };

    const checkLimitCountText = () => {
      if (!recommendItem) return '';
      const totalGuest = useOrderStore.getState().totalGuest;
      const max = recommendItem.isMaxPerPerson ? recommendItem.maxAllowed! * totalGuest : recommendItem.maxAllowed;
      const min = recommendItem.minRequired;
      if (max && min && min > 1) {
        return `Order ${min} to ${max}`;
      } else if (max) {
        return `Order up to ${max}`;
      } else if (min && min > 1) {
        return `Order at least ${min}`;
      }
      return '';
    };
  
    // Context value를 useMemo로 최적화하여 불필요한 리렌더링 방지
    const contextValue = React.useMemo(() => ({
      recommendItem, 
      selectRequired,
      setSelectRequired,
      setRecommendItem, 
      handleClose, 
      handleAddCount, 
      handleSubCount, 
      handleAddtoCart, 
      checkLimitCountText
    }), [recommendItem, selectRequired, setSelectRequired, handleClose, handleAddCount, handleSubCount, handleAddtoCart, checkLimitCountText]);
    
    if(!recommendItem) return (<></>) 
    
    return (
      <RecommendDetailContext.Provider value={contextValue}>
        <Portal>
          <Box className={`dialog ${openRecommend ? 'show' : ''}`} onClick={handleClose} >
            <DynamicDetail />
          </Box>
        </Portal>
      </RecommendDetailContext.Provider>
    )
  }
 
export default RecommendItemMain